import { parseDecimal, unparseCurrency } from 'utils/parsers';
import { PGTO } from './valorParcela';

/**
 * calcula o valores e taxas de um financiamento
 * Giovani 09/01/2026
 * @param {object} proposta - dados ja cadsatrados da proposta bancaria
 * @param {object} taxas - dados das taxas aplicadas no financiamento
 * @returns {object} - retorn array com os valores calculados
 */
export function calculaFinanciamento(proposta, taxas) {
  //valores fixos
  const valorEntrada = proposta?.valor_entrada || 0;
  const valor_financiamento = unparseCurrency(
    proposta?.valor_financiamento || '0'
  );
  const valorBem = unparseCurrency(proposta.valor_venda); //valorEntrada + valor_financiamento;

  const prazoMeses = parseInt(proposta?.prazo_financiamento);
  //taxas

  const perTac = parseFloat(proposta.tacSN) || 0;
  const perSeguro =
    proposta?.seguroSN === 'Sim' ? parseFloat(taxas?.perc_seguro) : 0;

  const valorSeguroAss =
    proposta?.seguroAssisSN === 'Sim' ? taxas?.valor_seguro_assistencia : 0;
  const perTaxa = parseFloat(taxas?.perc_taxa) || 0;
  const perTabela = proposta?.tabSN || 0;

  const iof = taxas?.iof;
  const iof_mais = taxas?.iof_mais;
  const iof_pf = taxas?.perc_iof_pf;
  const iof_pj = taxas?.perc_iof_pj;

  const tempoIof = prazoMeses * 30;
  //faz o calculo do iof esta com padrao o iof PF, se for colocar o do iof PF, fazer a comparacao aqui.
  let taxaIof;
  if (tempoIof >= 360) {
    taxaIof = iof_pf * 360;
  } else {
    taxaIof = iof_pf * tempoIof;
  }

  const perIof = proposta?.iofSN === 'Sim' ? parseFloat(taxaIof.toFixed(2)) : 0;

  //carencia padrão
  const carenciaPadrao = proposta?.carencia; //taxas?.carencia_padrao;

  //calculos
  const valorTac =
    taxas.calculo_tac === 'fixo'
      ? taxas.valor_tac_fixo
      : (perTac / 100) * valor_financiamento;
  const valorTab = (perTabela / 100) * valor_financiamento;
  const valorSeguro = (perSeguro / 100) * valor_financiamento;
  let valorIof =
    (perIof / 100) *
    (valor_financiamento + valorTac + valorSeguro + valorTab + valorSeguroAss);
  valorIof = parseFloat(valorIof.toFixed(2));
  // let adicionalIof =
  //   (iof_mais / 100) *
  //   (valor_financiamento +
  //     valorTac +
  //     valorSeguro +
  //     valorTab +
  //     valorSeguroAss +
  //     valorIof);
  //arredonda o valor do IofAdicional para 2 casas decimais
  // adicionalIof = parseFloat(adicionalIof.toFixed(2));
  //Refaz o IOF adicioanndo ele mesmo no calculo, pois o iof tem incidência sobre ele mesmo e sobre o adicional do iof.
  valorIof =
    (perIof / 100) *
    (valor_financiamento +
      valorTac +
      valorSeguro +
      valorTab +
      valorSeguroAss +
      valorIof);
  // //Calcula o adicional de IOF
  // adicionalIof =
  //   (iof_mais / 100) *
  //   (valor_financiamento +
  //     valorTac +
  //     valorSeguro +
  //     valorTab +
  //     valorSeguroAss +
  //     valorIof +
  //     adicionalIof);
  //Valor final do IOF com o IOF adicional incluso
  valorIof = valorIof;

  const valorTaxa = (perTaxa / 100) * valor_financiamento;
  const valorPresente =
    valor_financiamento +
    valorTac +
    valorSeguro +
    valorTab +
    valorIof +
    valorSeguroAss;
  //calculo do valor da parcela
  const valorParcela =
    PGTO(perTaxa / 100, prazoMeses, -valorPresente, 0, 0) *
    Math.pow(1 + perTaxa / 100, (carenciaPadrao - 30) / 30);
  //salva os calculos na proposta em segundo objeto
  const resultado = {
    valorBem: parseFloat(valorBem.toFixed(2)),
    valorTac: parseFloat(valorTac.toFixed(2)),
    valorSeguro: parseFloat(valorSeguro.toFixed(2)),
    valorTaxa: parseFloat(valorTaxa.toFixed(2)),
    valorTab: parseFloat(valorTab.toFixed(2)),
    valorIof: parseFloat(valorIof.toFixed(2)),
    valorPresente: parseFloat(valorPresente.toFixed(2)),
    valorParcela: parseFloat(valorParcela.toFixed(2)),
    valorSeguroAssis: valorSeguroAss,
    perSeguro: perSeguro,
  };

  return resultado;
}

/**
 * Simulação simples da função TAXA do Excel
 * (sem precisão, sem validações, sem controle numérico)
 */
//feito por IA

export async function taxaCET(nper, pgto, vp, vf = 0, tipo = 0, chute = 0.1) {
  let r = chute;
  function f(x) {
    const a = Math.pow(1 + x, nper);
    // Equação: 0 = vp*(1+r)^n + pgto*(1+r*tipo)*((1+r)^n - 1)/r + vf
    return vp * a + (pgto * (1 + x * tipo) * (a - 1)) / x + vf;
  }
  for (let i = 0; i < 100; i++) {
    const fx = f(r);
    const h = 1e-7; // passo fixo pra derivada numérica
    const dfx = (f(r + h) - f(r - h)) / (2 * h);
    r = r - fx / dfx;
  }

  return (r * 100).toFixed(2);
}

/**
 * calcula o valores e taxas no cobranca
 * Carlos 24/02/2026
 *
 * Espelha a aba `pmt_ren` de docs/formulas NEG_RENEG.xlsx — as referencias
 * de celula nos comentarios sao dessa aba. Ao mudar a regra, mude a planilha
 * junto (ou o contrario), senao os dois voltam a divergir.
 *
 * @param {object} proposta - dados ja cadsatrados. `carencia` e o numero de
 *   dias corridos ate a 1a parcela (E6 da planilha)
 * @param {object} taxas - dados das taxas aplicadas na cobranca
 * @returns {object} - retorn array com os valores calculados
 */
export function calculaCobranca(proposta, taxas) {
  // Todo numero passa pelo parseDecimal: vem de campo de formulario (pode ser
  // "", "2,19" ou undefined), e um NaN em qualquer termo zerava a PMT e
  // deixava o valor presente em "R$ NaN".
  //valores fixos
  const valor_financiamento = parseDecimal(proposta?.valor_renegociar); // D2
  const valor_entrada = parseDecimal(proposta?.valor_entrada); // D3
  const valor_finanEntrada = valor_financiamento - valor_entrada; // D4
  const prazoMeses = parseInt(proposta?.prazo); // C10
  //taxas
  //periodicidade padrão
  const periodicidadePadrao = Number(proposta?.periodicidade) || 30; // C9
  // E6. Sem data valida, assume a 1a parcela a um periodo de hoje.
  const carencia = Number.isFinite(proposta?.carencia)
    ? proposta.carencia
    : periodicidadePadrao;

  const perTac = parseDecimal(taxas?.perc_tacSN);
  // Percentual do seguro vem do cadastro do distribuidor. Sem cadastro, entra
  // como zero.
  const perSeguro =
    proposta?.seguroSN === 'Sim'
      ? parseDecimal(taxas?.taxas?.[0]?.perc_seguro)
      : 0;
  const perTabela = parseDecimal(taxas?.perc_tabSN);

  //variaveis do iof
  const iofPF = parseDecimal(taxas?.taxasiof?.iof_pf);
  // E16: prazo em meses de 30 dias, com teto de 360, vezes a aliquota diaria.
  // Sem IOF adicional e sem gross-up.
  const tempoIof = Math.min(prazoMeses * 30, 360);
  const perIof = proposta?.iofSN === 'Sim' ? (iofPF * tempoIof) / 100 : 0;

  const valorSeguroAss =
    proposta?.seguroAssisSN === 'Sim'
      ? parseDecimal(taxas?.taxasbanco?.valor_seguro_assistencia)
      : 0; // D14

  const taxaRenegocio = parseDecimal(proposta?.taxa); // C8
  const perTaxa = (taxaRenegocio / 30) * periodicidadePadrao;

  // D6: juros simples de carencia somados ao principal — taxa diaria
  // (taxa/30) vezes os dias corridos ate a 1a parcela.
  const valorCarencia =
    valor_finanEntrada * (1 + (taxaRenegocio / 30 / 100) * carencia);

  //calculos — tarifas e IOF sobre o D4, sem a carencia
  const valorTac = (perTac / 100) * valor_finanEntrada; // D12
  const valorSeguro = (perSeguro / 100) * valor_finanEntrada; // D13
  const valorTab = (perTabela / 100) * valor_finanEntrada; // D15
  const valorIof = perIof * valor_finanEntrada; // D16
  const valorTaxa = (perTaxa / 100) * valor_finanEntrada;

  //valor presente (D18)
  const valorPresente =
    valorCarencia +
    valorTac +
    valorSeguro +
    valorSeguroAss +
    valorTab +
    valorIof;

  //calculo do valor da parcela (C20): PGTO postecipado, sem fator de
  //carencia — ela ja entrou no principal pelo D6.
  const valorParcela = PGTO(perTaxa / 100, prazoMeses, -valorPresente, 0, 0);
  //salva os calculos na proposta em segundo objeto
  //caso seja zerado o valor de renegociar vai estar trazendo os valores zerado.
  if (proposta.valor_renegociar <= 0) {
    const resultado = {
      valor_financiamento: 0,
      valorBem: 0,
      valorTac: 0,
      valorSeguro: 0,
      valorTaxa: 0,
      valorTab: 0,
      valorIof: 0,
      valorPresente: 0,
      valorParcela: 0,
      perSeguro: 0,
    };
    return resultado;
  }
  const resultado = {
    valor_financiamento: parseFloat(valor_financiamento.toFixed(2)),
    valorBem: parseFloat(valor_financiamento.toFixed(2)),
    valorTac: parseFloat(valorTac.toFixed(2)),
    valorSeguro: parseFloat(valorSeguro.toFixed(2)),
    valorSeguroAssis: valorSeguroAss,
    valorTaxa: parseFloat(valorTaxa.toFixed(2)),
    valorTab: parseFloat(valorTab.toFixed(2)),
    valorIof: parseFloat(valorIof.toFixed(2)),
    valorPresente: parseFloat(valorPresente.toFixed(2)),
    valorParcela: parseFloat(valorParcela.toFixed(2)),
    perSeguro: perSeguro,
  };

  return resultado;
}

function calcularIOF(valorLiberado, tarifas = 0, diasOperacao) {
  if (valorLiberado <= 0) {
    throw new Error('Valor liberado deve ser maior que zero.');
  }

  // Base de calculo do IOF (vl principal + tarifas)
  const baseCalculo = valorLiberado + tarifas;

  // aliquotas oficiais
  const IOF_FIXO = 0.0038; // 0,38% adicional
  const IOF_DIARIO = 0.000082; // 0,0082% ao dia

  // Cálculo
  const iofFixo = baseCalculo * IOF_FIXO;
  const iofDiario = baseCalculo * IOF_DIARIO * Math.min(diasOperacao, 365); // max 365 dias

  const iofTotal = iofFixo + iofDiario;
  return Number(iofTotal.toFixed(2));
}
